import { render, staticRenderFns } from "./EditBatch.vue?vue&type=template&id=cc5e5218&scoped=true"
import script from "./EditBatch.vue?vue&type=script&lang=js"
export * from "./EditBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5e5218",
  null
  
)

export default component.exports